import GenericScreen from "../../../GenericScreen";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";

import GenericPhoneScreen from "../../../GenericPhoneScreen";
import imgScreen from "../../../../../../Assets/StoryPassenger/PHONE_17.png";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

interface ScreenProps {
  transition: number;
}

const Screen = (props: ScreenProps) => {
  const { transition } = props;

  return (
    <GenericScreen
      showComponent={transition >= 4}
      showContent={true}
      icon={<AlternateEmailIcon sx={styles.icon} />}
      title={"Personalised suggestions"}
      text={"Skip this for now and explore the duty-free stores"}
      panelRight={<GenericPhoneScreen imgScreen={imgScreen} bottom={"35.01vh"} width={"33.3vh"} height={"5.1vh"} left={"3.6vh"} />}
    />
  );
};

const styles = {
  icon: {
    fontSize: "5.2083em",
    color: "#00B28F",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
  };
};

export default connectWithDispatch(Screen, mapStateToProps);
